import { ResumeSkills } from "lib/redux/types";
import React from "react";
import { TemplateElevenResumeSection } from "./common";
import {
  ResumePDFDescription,
  ResumePDFSkillsTwoColumn,
} from "../ResumePDF/common";
import { View } from "@react-pdf/renderer";
import { styles } from "../ResumePDF/styles";

const Skills = ({
  heading,
  skills,
  themeColor,
  showBulletPoints,
}: {
  heading: string;
  skills: ResumeSkills;
  themeColor: string;
  showBulletPoints: boolean;
}) => {
  const { descriptions } = skills;
  return (
    <TemplateElevenResumeSection themeColor={themeColor} heading={heading}>
      <View wrap={false} style={{ ...styles.flexCol }}>
      <ResumePDFSkillsTwoColumn items={descriptions} />
      </View>
    </TemplateElevenResumeSection>
  );
};

export default Skills;
